/**
 * /eternaldurdles copy (Asana 1219910162763584). Every user-facing string on the
 * partner landing page lives here so the page test asserts the same text.
 * Rules: no "$15", no em dashes, no revolutionary / seamless / community-driven /
 * innovative, no PucaTrade, and never "the moment you verify" for the 1,600.
 *
 * The 1,600 is the sum of the onboarding checklist rewards (phone verify pays 100
 * on its own); it is held here the way setupCopy.ts holds bodyPoints: 1600.
 */

/** Shared with the backend crawler meta route for this path; keep the two identical. */
export const ED_PAGE_TITLE = 'Eternal Durdles x TradeMagic - Create a Free Account and Start Trading';
export const ED_PAGE_DESCRIPTION =
  "Listeners of Eternal Durdles can create a free TradeMagic account and earn up to 1,600 points ($16 in trade credit) by setting up their account. Trade the cards you're not playing for the ones you want.";
export const ED_PAGE_KEYWORDS =
  'Eternal Durdles, TradeMagic, MTG podcast partner, free account, Premodern, Old School, Legacy, Magic card trading';

export const ED_HERO = {
  headline: 'Welcome, Durdlers.',
  subhead: "Trade the cards you're not playing for the ones you want.",
} as const;

export const ED_OFFER = {
  eyebrow: 'FREE ACCOUNT',
  /** Rendered as "Up to {Points 1,600} points ($16 in trade credit) for setting up your account." */
  lead: 'Up to',
  points: 1600,
  tail: ' points ($16 in trade credit) for setting up your account.',
  sub: '100 the moment you verify your phone, the rest as you add wants and trade.',
  cta: 'Create your free account',
  ctaSignedIn: 'Go to Home',
  formats: 'Spend it today on cards for your next Premodern, Old School, or Legacy deck.',
  haveAccount: 'Already have an account?',
  signIn: 'Sign in',
} as const;

export const ED_HOW = {
  heading: 'How it works',
  steps: [
    {
      title: "Add cards you're not using",
      body: "List what's sitting in your binder, or import a CSV.",
    },
    {
      title: 'Earn points when they ship',
      body: 'When another player wants a card, you mail it and get points.',
    },
    {
      title: 'Spend points on cards you want',
      body: 'Pick what you need and another player ships it to you.',
    },
  ],
} as const;

export const ED_PROOF = 'Zac and Phil trade here. Catch the monthly Trade Report on the show.';

export const ED_ELITE_STRIP = {
  text: 'Want more? Elite is $5.99/mo.',
  link: "See what's in Elite",
} as const;

/** The Elite strip's destination. Plain /elite (Eric's ruling 2026-10-28). */
export const ED_ELITE_LINK_HREF = '/elite';
